export const PopupLoaderTypes = {
  incomeVerification: 'incomeVerification',
  kyc: 'kyc',
  esign: 'esign',
  emandate: 'emandate',
};

type ErrorCodeType = {
  timeout: string;
  close: string;
};

export const PopupLoaderErrorsMapping: {
  [x in string]: ErrorCodeType;
} = {
  incomeVerification: {
    timeout: 'As the verification process couldn’t be completed in time',
    close: 'As the verification process was cancelled',
  },
  kyc: {
    timeout: 'As the kyc verification process couldn’t be completed in time',
    close: 'As the kyc verification process was cancelled',
  },
  esign: {
    timeout: 'As the e-sign process couldn’t be completed in time',
    close: 'As the e-sign process was cancelled',
  },
  emandate: {
    timeout: 'As the Emandate payment couldn’t be completed in time',
    close: 'As the Emandate payment process was cancelled',
  },
};

export const POPUP_TIMEOUT_LIMIT = {
  incomeVerification: 7 * 60 * 1000,
  kyc: 7 * 60 * 1000,
  esign: 7 * 60 * 1000,
  emandate: 0,
};
